import { useState, useEffect } from "react";
import { api } from "@/lib/api-client";

interface JobType {
  id: string;
  name: string;
}

interface FilterBarProps {
  jobTypeId?: string;
  from?: string;
  to?: string;
  onFilter: (jobTypeId: string | undefined, from: string | undefined, to: string | undefined) => void;
}

export function FilterBar({ jobTypeId, from, to, onFilter }: FilterBarProps) {
  const [jobTypes, setJobTypes] = useState<JobType[]>([]);
  const [localJobTypeId, setLocalJobTypeId] = useState(jobTypeId ?? "");
  const [localFrom, setLocalFrom] = useState(from ?? "");
  const [localTo, setLocalTo] = useState(to ?? "");

  useEffect(() => {
    api.get<{ items: JobType[] }>("/job-types").then((res) => {
      setJobTypes(res.items ?? []);
    }).catch(() => {
      // Non-fatal — just show no options
    });
  }, []);

  function handleApply() {
    onFilter(
      localJobTypeId || undefined,
      localFrom || undefined,
      localTo || undefined,
    );
  }

  function handleReset() {
    setLocalJobTypeId("");
    setLocalFrom("");
    setLocalTo("");
    onFilter(undefined, undefined, undefined);
  }

  return (
    <div className="analytics-filter-bar">
      <div className="analytics-filter-group">
        <label className="analytics-filter-label">Job Type</label>
        <select
          className="analytics-filter-input"
          value={localJobTypeId}
          onChange={(e) => setLocalJobTypeId(e.target.value)}
        >
          <option value="">All Job Types</option>
          {jobTypes.map((jt) => (
            <option key={jt.id} value={jt.id}>
              {jt.name}
            </option>
          ))}
        </select>
      </div>

      <div className="analytics-filter-group">
        <label className="analytics-filter-label">From</label>
        <input
          type="date"
          className="analytics-filter-input"
          value={localFrom}
          onChange={(e) => setLocalFrom(e.target.value)}
        />
      </div>

      <div className="analytics-filter-group">
        <label className="analytics-filter-label">To</label>
        <input
          type="date"
          className="analytics-filter-input"
          value={localTo}
          onChange={(e) => setLocalTo(e.target.value)}
        />
      </div>

      <div className="analytics-filter-actions">
        <button className="analytics-filter-btn analytics-filter-btn--apply" onClick={handleApply}>
          Apply
        </button>
        <button className="analytics-filter-btn analytics-filter-btn--reset" onClick={handleReset}>
          Reset
        </button>
      </div>
    </div>
  );
}
